import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import sensor_actions from '@devices/settings/device_settings/sensor_actions.js';
import external_sensors from '@devices/settings/device_settings/external_sensors.js';
import ext_temperature from '@devices/settings/device_settings/ext_temperature.js';
import ext_humidity from '@devices/settings/device_settings/ext_humidity.js';
import app_setting_gen_2 from '@devices/settings/device_settings/app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import { createSceneCapabilities } from '@components/Flows/sceneCapabilities/index.js';

export default {
	name: 'shelly1',
	friendly_name: '1',
	family: 'relay',
	isPM: false,
	modes: {
		relay: {
			sceneCapabilities: createSceneCapabilities({
				template: 'single_relay_gen1',
			}),
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights', 'overtemperature'],
			settings: [
				timer,
				schedule,
				actions,
				sensor_actions,
				external_sensors,
				ext_temperature,
				ext_humidity,
				{
					title: 'networks',
					components: [
						{ title: 'wifi_mode_client', component: 'wifi_mode_client' },
						{ title: 'wifi_client_backup', component: 'wifi_client_backup' },
						{ title: 'wifi_mode_ap', component: 'wifi_mode_ap' },
						{ title: 'wifi_ap_roaming', component: 'wifi_ap_roaming' },
						{ title: 'restrict_login', component: 'restrict_login' },
						{ title: 'cloud', component: 'cloud' },
					],
				},
				app_setting_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'power_on_default', component: 'power_on_default_rr' },
						{ title: 'button_type', component: 'button_type_pm' },
						{ title: 'long_push', component: 'long_push' },
						{ title: 'ext_switch', component: 'ext_switch' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
			hideFromIoActions: [
				'ext_hum_over_url',
				'ext_hum_under_url',
				'ext_temp_over_url',
				'ext_temp_under_url',
			],
		},
	},
};
